
import Vue from 'vue';
import TextInput from '@shared/components/TextInput.vue';
import CheckboxInput from '@shared/components/CheckboxInput.vue';

export default Vue.extend({
  name: 'StepTwo',
  components: {
    TextInput,
    CheckboxInput,
  },
  props: {
    info: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      errors: [''],
      noProducts: false,
      userInfo: {
        solar: false,
        charger: false,
        name: '',
        email: '',
        phone: '',
        businessName: '',
        businessOrgNumber: '',
        fromAddress: '',
        fromZip: '',
        fromDate: '',
        toAddress: '',
        toZip: '',
        toDate: '',
        meterid: '',
        endInvoice: '',
        isBusinessUser: false,
        userDescription: '',
        continuePayment: false,
      },
    };
  },
  mounted() {
    this.userInfo = this.info;
  },
  methods: {
    previous(): void {
      this.$emit('previous');
    },
    next(): void {
      if (this.checkForm()) {
        this.$emit('next', this.userInfo);
      }
    },
    send(): void {
      if (this.checkForm()) {
        this.$emit('send', this.userInfo);
      }
    },
    checkForm(): boolean {
      this.errors = [];

      if (this.userInfo.isBusinessUser && !this.userInfo.businessName) {
        this.errors.push('Mangler bedriftsnavn.');
      }

      if (!this.userInfo.name) {
        this.errors.push('Mangler navn.');
      }
      if (!this.userInfo.email) {
        this.errors.push('Mangler epost.');
      }
      if (!this.userInfo.phone) {
        this.errors.push('Mangler telefon.');
      }
      if (!this.userInfo.fromAddress) {
        this.errors.push('Mangler adresse.');
      }
      if (!this.userInfo.fromDate) {
        this.errors.push('Mangler utflyttingsdato.');
      }
      if (!this.noProducts) {
        if (!this.userInfo.toAddress) {
          this.errors.push('Mangler ny adresse.');
        }
        if (!this.userInfo.toDate) {
          this.errors.push('Mangler innflyttingsdato.');
        }
      }

      if (!this.errors.length) {
        return true;
      }
      return false;
    },
  },
});
